module.exports = __webpack_public_path__ + "static/media/waag.060324f4.png";